module.exports = __webpack_public_path__ + "img/treatment-pack-2.d497c55e.png";